import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IconModule } from '../../notes/icon/icon.module';
import { NbspRemoveModule } from '../../shared/modules/nbsp-remove-pipe/nbsp-remove-pipe.module';

import { LinkModule } from '../link/link.module';
import { CareCardComponent } from './care-card.component';
import * as Pipes from './care-card.pipes';
import { CareCardCardComponent } from './components/card/card.component';
import { CareCardFooterComponent } from './components/care-card-footer/care-card-footer.component';

@NgModule({
  declarations: [
    CareCardComponent,
    CareCardCardComponent,
    Pipes.FilterCareCardDentistsPipe,
    Pipes.FormatCareCardChangeTextPipe,
    Pipes.FormatCareCardNamePipe,
    Pipes.FormatCareCardPhoneNumberPipe,
    Pipes.CareCardLinkConfigPipe,
    Pipes.CareCardExternalLinkConfigPipe,
    Pipes.FormatCareCardTitlePipe,
    CareCardFooterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    IconModule,
    LinkModule,
    NbspRemoveModule,
  ],
  exports: [CareCardComponent],
})
export class CareCardModule {}
